// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-entity-component',
    // #endregion
    // #region Props
    props: {
        window: Object
    },
    // #endregion
    // #region Data
    data: () => ({
        _component: null,
        _componentProps: null,
    }),
    // #endregion
    // #region Created
    created() {
        this.calculate();
    },
    // #endregion
    // #region Watch
    watch: {
        "window"(value) {
            this.calculate();
        },
    },
    // #endregion
    // #region Run
    methods: {
        calculate() {
            if (this.window) {
                //Result
                let tResult = this.window.component;
                //Run
                if (tResult?.component) {
                    this._component = tResult.component;
                    this._componentProps = tResult?.componentProps;
                }
            }
        },
        close() {
            if (this.window) {
                this.$router.closeWindow(this.window);
            }
        },
    }
    // #endregion
});
// #endregion
